import { atom, getDefaultStore, useAtom } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils';
import { COMPANY_SWITCHED_EVENT } from '~/hooks/useActiveCompany';

const selectedPeriodAtom = atomWithStorage<string | null>('bookkeeping-settlement-selected-period', null, undefined, {
  getOnInit: true,
});

const exportingVATBooksAtom = atom<string | null>(null);

export const useSelectedPeriod = () => useAtom(selectedPeriodAtom);

export const useIsExportingVATBooks = (): boolean => {
  const [tracingId] = useAtom(exportingVATBooksAtom);
  return tracingId !== null;
};

export const setExportingVATBooks = (tracingId: string): void => {
  const store = getDefaultStore();
  store.set(exportingVATBooksAtom, tracingId);

  setTimeout(() => {
    if (store.get(exportingVATBooksAtom) === tracingId) {
      store.set(exportingVATBooksAtom, null);
    }
  }, 10000);
};

export const clearExportingVATBooks = (tracingId: string): boolean => {
  const store = getDefaultStore();
  if (store.get(exportingVATBooksAtom) === tracingId) {
    store.set(exportingVATBooksAtom, null);
    return true;
  }
  return false;
};

// Reset all filters when the company changes
window.addEventListener(COMPANY_SWITCHED_EVENT, () => {
  const store = getDefaultStore();
  store.set(selectedPeriodAtom, RESET);
  store.set(exportingVATBooksAtom, null);
});
